module.exports = __webpack_public_path__ + "static/img/frame.67dd8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DOM/EffectFilter/img/frame.png
// module id = 472
// module chunks = 0